import React, { useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from "@material-ui/core";
import { OrganizedItem } from "../../../_models";
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
    emptyColSpans: {
        background: '#fff !important'
    },
    totalRow: {
        background: '#cdcdcd !important'
    },
    totalCell: {
        color: 'white !important',
        background: '#505050 !important'
    },
    bestCycleTimesCycles: {
        color: 'black !important',
        background: 'rgba(104, 153, 232, 0.6) !important',
        textAlign: 'center'
    },
});

const BestCTReportList: React.FC<{
    totalSSV: number;
    totalBestCT: number;
    moduleOrPlants: string[];
    bestCTTotals: number[];
    cycleCountTotals: number[];
    organizedItems: OrganizedItem[];
}> = (props) => {
    const classes = useStyles();
    // const [totalColumns, setTotalColumns] = useState((props.moduleOrPlants.length * 2) + 6)

    return (
        <TableContainer style={{ minWidth: '1400px', maxWidth: '1484px' }}>
            <Table size="small" stickyHeader aria-label="sticky table" className={'appTable'}>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.emptyColSpans} colSpan={4}></TableCell>
                        <TableCell className={classes.bestCycleTimesCycles} colSpan={props.moduleOrPlants.length}>
                            <Typography>Best Cycle Times</Typography>
                        </TableCell>
                        <TableCell className={classes.emptyColSpans} colSpan={2}></TableCell>
                        <TableCell className={classes.bestCycleTimesCycles} colSpan={props.moduleOrPlants.length}>
                            <Typography>No of cycles</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Typography>No.</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>GSD Code</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>Operation</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>SSV</Typography>
                        </TableCell>
                        {
                            props.moduleOrPlants.map(
                                (moduleOrPlants: string, i: number) =>
                                    <TableCell key={i}>
                                        <Typography>{moduleOrPlants}</Typography>
                                    </TableCell>
                            )
                        }
                        <TableCell>
                            <Typography>Best CT</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>EPF - Team Member Name</Typography></TableCell>
                        {
                            props.moduleOrPlants.map(
                                (moduleOrPlants: string, i: number) =>
                                    <TableCell key={i}>
                                        <Typography>{moduleOrPlants}</Typography>
                                    </TableCell>
                            )
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.organizedItems.map((row: OrganizedItem, i: number) => {
                        return (
                            <TableRow key={`${row.operationName}_${i}`}>
                                <TableCell>
                                    <Typography>{i + 1}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography>{row.gsdCode}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography>{row.operationName}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography>{row.ssv}</Typography>
                                </TableCell>
                                {
                                    row.bestCTs.map(
                                        (bestCT: number, i: number) =>
                                            <TableCell key={i}>
                                                <Typography>{bestCT == 0 ? '-' : bestCT}</Typography>
                                            </TableCell>
                                    )
                                }
                                <TableCell>
                                    <Typography>{row.bestCT}</Typography>
                                </TableCell>
                                <TableCell>
                                    {
                                        row.teamMemberName.map(
                                            (member: string, j: number) =>
                                                <Typography key={j}>{member}</Typography>
                                        )
                                    }
                                </TableCell>
                                {
                                    row.cycleCounts.map(
                                        (cycleCount: number[], i: number) =>
                                            <TableCell key={i}>
                                                {
                                                    cycleCount.length == 0 ? <Typography>-</Typography> :
                                                        cycleCount.map(
                                                            (count: number, j: number) =>
                                                                <Typography key={j}>{count}</Typography>
                                                        )
                                                }
                                            </TableCell>
                                    )
                                }
                            </TableRow>
                        )
                    })}
                    <TableRow className={classes.totalRow}>
                        <TableCell colSpan={2}></TableCell>
                        <TableCell>
                            <Typography>Total Seconds</Typography>
                        </TableCell>
                        <TableCell className={classes.totalCell}>
                            <Typography>{props.totalSSV.toFixed(2)}</Typography>
                        </TableCell>
                        {
                            props.bestCTTotals.map(
                                (bestCTTotal: number, i: number) =>
                                    <TableCell className={classes.totalCell} key={i}>
                                        <Typography>{bestCTTotal.toFixed(2)}</Typography>
                                    </TableCell>
                            )
                        }
                        <TableCell className={classes.totalCell}>
                            <Typography>{props.totalBestCT.toFixed(2)}</Typography>
                        </TableCell>
                        <TableCell></TableCell>
                        {
                            props.cycleCountTotals.map(
                                (cycleCountTotal: number, i: number) =>
                                    <TableCell className={classes.totalCell} key={i}>
                                        <Typography>{cycleCountTotal}</Typography>
                                    </TableCell>
                            )
                        }
                    </TableRow>
                    <TableRow className={classes.totalRow}>
                        <TableCell colSpan={2}></TableCell>
                        <TableCell>
                            <Typography>Total Minutes</Typography>
                        </TableCell>
                        <TableCell className={classes.totalCell}>
                            <Typography>{(props.totalSSV / 60).toFixed(2)}</Typography>
                        </TableCell>
                        {
                            props.bestCTTotals.map(
                                (bestCTTotal: number, i: number) =>
                                    <TableCell className={classes.totalCell} key={i}>
                                        <Typography>{(bestCTTotal / 60).toFixed(2)}</Typography>
                                    </TableCell>
                            )
                        }
                        <TableCell className={classes.totalCell}>
                            <Typography>{(props.totalBestCT / 60).toFixed(2)}</Typography>
                        </TableCell>
                        <TableCell colSpan={props.moduleOrPlants.length + 1}></TableCell>
                    </TableRow>

                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default BestCTReportList;
